// extracted by mini-css-extract-plugin
export default {"wrapper":"oJJnP","topContainer":"K5JOt","title":"_6qxM5","description":"FkdyQ","list":"fC76q","videoContainer":"laYbS","video":"sure4"};